import PropTypes from "prop-types";
import { Card, Icon } from "@mui/material";

import SoftBadge from "components/SoftBadge";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { makeNiceText } from "utils/formatters";

function CotizacionCard({ item, onSelect, idProveedor, colores }) {
  const nombre = item?.nombre ? makeNiceText(item.nombre, "nombre") : `Pedido n° ${item?.id}`;
  const proveedorGano = item?.provisiones?.some((provision) => !provision.anulada);
  const proveedorCotizo = item?.cotizaciones?.some(
    (cotizacion) => String(cotizacion.idProveedor) === String(idProveedor)
  );
  const estadoProveedor = proveedorGano ? "Ganado" : proveedorCotizo ? "Licitado" : "Sin cotizar";
  const colorEstadoProveedor = proveedorGano ? "uproGreen" : proveedorCotizo ? "uproBlue" : "secondary";

  return (
    <Card
      component="button"
      type="button"
      onClick={() => onSelect(item)}
      aria-label={`Ver detalle de la cotización ${item?.id}: ${nombre}`}
      sx={{
        width: "100%",
        border: "1px solid #e9ecef",
        borderRadius: 2,
        boxShadow: "none",
        backgroundColor: "#ffffff",
        color: "inherit",
        font: "inherit",
        textAlign: "left",
        cursor: "pointer",
        transition: "border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease",
        "&:hover": {
          borderColor: "primary.main",
          boxShadow: "0 6px 18px rgba(52, 71, 103, 0.12)",
          backgroundColor: "#fffafd",
        },
        "&:focus-visible": {
          outline: "3px solid rgba(240, 5, 122, 0.35)",
          outlineOffset: 2,
        },
      }}
    >
      <SoftBox p={{ xs: 2, sm: 2.25 }} display="flex" alignItems="center" gap={1.5}>
        <SoftBox minWidth={0} flex={1}>
          <SoftTypography variant="caption" color="dark" fontWeight="bold" display="block">
            PEDIDO #{item?.id}
          </SoftTypography>
          <SoftTypography
            variant="button"
            color="dark"
            fontWeight="bold"
            display="block"
            mt={0.45}
            sx={{ overflowWrap: "anywhere", lineHeight: 1.35 }}
          >
            {nombre}
          </SoftTypography>
          <SoftBox display="flex" flexWrap="wrap" gap={0.65} mt={1}>
            <SoftBadge
              size="xs"
              variant="gradient"
              badgeContent={item?.licitacionEstado || "Sin estado"}
              color={colores[item?.licitacionEstado] || "primary"}
            />
            <SoftBadge
              size="xs"
              variant="gradient"
              badgeContent={estadoProveedor}
              color={colorEstadoProveedor}
            />
          </SoftBox>
        </SoftBox>
        <SoftBox
          display="grid"
          sx={{
            placeItems: "center",
            width: 34,
            height: 34,
            borderRadius: "50%",
            backgroundColor: "rgba(240, 5, 122, 0.08)",
            color: "primary.main",
            flex: "0 0 auto",
          }}
        >
          <Icon sx={{ fontSize: "18px !important" }}>chevron_right</Icon>
        </SoftBox>
      </SoftBox>
    </Card>
  );
}

CotizacionCard.propTypes = {
  item: PropTypes.object.isRequired,
  onSelect: PropTypes.func.isRequired,
  idProveedor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  colores: PropTypes.object.isRequired,
};

CotizacionCard.defaultProps = {
  idProveedor: null,
};

export default CotizacionCard;
